import script from "./OrderQueryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderQueryPage.vue?vue&type=script&setup=true&lang=js"

import "./OrderQueryPage.vue?vue&type=style&index=0&id=464029c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464029c0"]])

export default __exports__